import { ModalStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';
import { Dispatch } from 'redux';

export const openModal =
  ({
    type = 'dialog',
    withHeader = true,
    withCloseBtn = true,
    preventClose = false,
    ...store
  }: Omit<ModalStore, 'show'>) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: Reducers.OPEN_MODAL,
      payload: { ...store, type, withHeader, withCloseBtn, preventClose },
    });
  };

export const closeModal =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({ type: Reducers.CLOSE_MODAL });
  };
